import React from 'react';
import clsx from 'clsx';

export interface SmartAssistSuggestionsProps {
  suggestions: string[];
  onSelect(suggestion: string): void;
  welcome?: boolean;
}

export function SmartAssistSuggestions({
  suggestions,
  onSelect,
  welcome = false,
}: SmartAssistSuggestionsProps): React.ReactElement | null {
  if (!suggestions.length) return null;

  return (
    <div className={clsx('smartAssist__quick-suggestions', welcome && 'smartAssist__quick-suggestions--welcome')}>
      {suggestions.map((s, idx) => (
        <button
          key={`${s}-${idx}`}
          type="button"
          className={clsx('smartAssist__quick-chip', welcome && 'smartAssist__quick-chip--welcome')}
          onClick={() => {
            onSelect(s);
          }}
        >
          {s}
        </button>
      ))}
    </div>
  );
}
